import { render, staticRenderFns } from "./inquiryPhoto.vue?vue&type=template&id=d1c38fda&scoped=true"
import script from "./inquiryPhoto.vue?vue&type=script&lang=js"
export * from "./inquiryPhoto.vue?vue&type=script&lang=js"
import style0 from "./inquiryPhoto.vue?vue&type=style&index=0&id=d1c38fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c38fda",
  null
  
)

export default component.exports